import { render, staticRenderFns } from "./SettingsChangePassword.vue?vue&type=template&id=72d601a0&scoped=true&"
import script from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./../../../../assets/mobileStyle.css?vue&type=style&index=0&id=72d601a0&prod&scoped=true&lang=css&"
import style1 from "./SettingsChangePassword.vue?vue&type=style&index=1&id=72d601a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d601a0",
  null
  
)

export default component.exports